function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "8CDFF11A-1E07-4F0A-BDE0-518C06B88519");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "6.73116624%",
  y1: "93.4850191%",
  x2: "93.5910491%",
  y2: "6.61873642%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDD55",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF543E",
  offset: "50%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C837AB",
  offset: "100%"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "03-Alter-Pros",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "03-Alter-Pros-/-01.3-Add-New-Alter-Pro",
  transform: "translate(-172.000000, -873.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-14",
  transform: "translate(171.000000, 776.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Social-Media-/-Instagram",
  transform: "translate(1.000000, 97.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.33333333,1.40468608 C-0.229177994,3.02767638 0.0906148867,4.7517411 0.0906148867,9.98938511 C0.0906148867,14.3388997 -0.668271845,18.6991845 3.30345631,19.7256699 C4.54368932,20.0446343 15.5326343,20.0446343 16.7712104,19.7240129 C18.4248544,19.2973463 19.7703042,17.9560388 19.9542265,15.6172427 C19.9799094,15.290822 19.9799094,4.69374757 19.9533981,4.36069903 C19.757877,1.86946278 18.2243625,0.433708738 16.2037023,0.142912621 C15.7405825,0.0758058252 15.6477929,0.0559223301 13.2717152,0.0517799353 C4.84359871,0.0559223301 2.99609061,-0.319378641 1.33333333,1.40468608 Z",
  id: "Path",
  fill: "url(#linearGradient-1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.0307055,2.6523754 C7.02249838,2.6523754 4.16590291,2.3847767 3.07479612,5.1850356 C2.62410356,6.34159223 2.6895534,7.8436246 2.6895534,9.99435599 C2.6895534,11.8816311 2.62907443,13.6554045 3.07479612,14.8028479 C4.16341748,17.6047638 7.04321036,17.3363366 10.0290485,17.3363366 C12.9096699,17.3363366 15.879767,17.636246 16.9841294,14.8028479 C17.4356505,13.6346926 17.3693722,12.1550291 17.3693722,9.99435599 C17.3693722,7.12616181 17.5276117,5.27451133 16.1365955,3.88432362 C14.7281812,2.47590939 12.8235081,2.6523754 10.0273916,2.6523754 L10.0307055,2.6523754 Z M9.3728932,3.97545631 C15.6477929,3.96551456 16.4464466,3.26793528 16.0056958,12.9586537 C15.8491133,16.3860712 13.2394045,16.0099417 10.031534,16.0099417 C4.18247249,16.0099417 4.01429126,15.842589 4.01429126,9.99104207 C4.01429126,4.07155987 4.47823948,3.97877023 9.3728932,3.97379935 L9.3728932,3.97545631 Z M13.949411,5.19414887 C13.4630939,5.19414887 13.0687379,5.58850485 13.0687379,6.07482201 C13.0687379,6.56113916 13.4630939,6.95549515 13.949411,6.95549515 C14.4357282,6.95549515 14.8300841,6.56113916 14.8300841,6.07482201 C14.8300841,5.58850485 14.4357282,5.19414887 13.949411,5.19414887 L13.949411,5.19414887 Z M10.0307055,6.22394822 C7.94873786,6.22394822 6.26112621,7.91238835 6.26112621,9.99435599 C6.26112621,12.0763236 7.94873786,13.7639353 10.0307055,13.7639353 C12.1126731,13.7639353 13.7994563,12.0763236 13.7994563,9.99435599 C13.7994563,7.91238835 12.1126731,6.22394822 10.0307055,6.22394822 Z M10.0307055,7.54702913 C13.2659159,7.54702913 13.2700583,12.4416828 10.0307055,12.4416828 C6.79632362,12.4416828 6.79135275,7.54702913 10.0307055,7.54702913 Z",
  id: "Shape",
  fill: "#FFFFFF"
}))))));

var SvgInstagram = function SvgInstagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram.383f4f91.svg";
export { ForwardRef as ReactComponent };